/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { logBannerCodeTried } from './Attribution-Actions';

const initialState = {
    bannerCodeTried: false,
};

const attributionReducer = (state = initialState, action) => {
    switch (action.type) {
        case logBannerCodeTried().type:
            return {
                ...state,
                bannerCodeTried: action.data.tried,
            };
        default:
            return state;
    }
};

export default attributionReducer;
